module.exports = __webpack_public_path__ + "static/media/Feebas_gaussian2.51136343.png";